// extracted by mini-css-extract-plugin
export default {"container":"Q2sI27iMNIhXUjwiH9Bp"};